import axios from 'axios';
import apiClient from '../ApiClient';
import { redirectToLoginPage } from '../../../helper';

const JobService = {
  getJobs: async (_params, instance) => {
    try {
      return (await apiClient.get('/jobs')).data;
    } catch (error) {
      console.error('Error fetching jobs:', error);
      if (error.response && error.response.status === 401) {
          redirectToLoginPage(instance);
      }
      return null;
    }
  },
  getJobBtNetwork: async(params, instance) => {
    try {
      return (await apiClient.post('/jobsByNetworkAndEnv',params)).data;
    } catch (error) {
      console.error('Error fetching jobs by Network:', error);
       if (error.response && error.response.status === 401) {
          redirectToLoginPage(instance);
      }
      return null;
    }
  },
  getjobStatusreport: async(params, instance) => {
    try {
      return (await apiClient.post('/getJobStatusData',params)).data;
    } catch (error) {
      console.error('Error fetching jobs Status:', error);
       if (error.response && error.response.status === 401) {
          redirectToLoginPage(instance);
      }
      return null;
    }
  },
};

export default JobService;
